<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/contactList' }">联系人</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="code：">
                                    <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"><el-form-item label="所有人："> </el-form-item> </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="名称：">
                                    <el-input v-model="list.name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="省份：">
                                    <el-input
                                        v-model="list.province_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="电话号码：">
                                    <el-input v-model="list.phone_number" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="城市：">
                                    <el-input v-model="list.city_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="通讯地址：">
                                    <el-input v-model="list.mail_address" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div></el-form-item
                                ></el-col
                            >
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div></el-form-item
                                ></el-col
                            >
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="联系人关联实体" name="2">
                    <vContactUpComponent v-if="flag" :postList="postList"></vContactUpComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vContactUpComponent from '../../listComponent/basicdata/contact/contactUpComponent.vue';
export default {
    inject: ['reload'],
    name: 'contactDetail',
    components: {
        vContactUpComponent
    },
    data() {
        return {
            list: {},
            activeNames: ['1', '2'],
            rid: '',
            headerTitle: '联系人详情',
            flag: false,
            postList: {
                headerTitle: false,
                addBtn: true,
                setBtn: true,
                params: {
                    contact_rid: ''
                }
            }
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.postList.params.contact_rid = this.$route.query.id;
            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.postList.params.contact_rid = this.$route.query.id;
        this.getDetails(); //获取详情
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .contactDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/contactList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'contactEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'contactEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'contactEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/contactList' });
            } else {
                this.$router.go(-1);
            }
        },
        //联系人详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .contactDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>